export const prepareDate = (date, sepFrom = '-', sepTo = '-') => {
    return date ? date.split(sepFrom).reverse().join(sepTo) : ''
}